import { defineStore } from "pinia";
import { rootGetters } from "@/main";

import { moveItemToFront } from "@/services/utils/Arrays"

const endpoints = {
    getWorkbooks: { method: "get", url: "/client_workbooks" },
    getWorkbook: { method: "get", url: "/client_workbooks/{client_workbook_id}" },
    deleteWorkbook: { method: "delete", url: "/client_workbooks/{client_workbook_id}" },
    getToken: { method: "post", url: "/dashboards/{dashboard_id}/token" },
    createWorkbook: { method: "post", url: "/client_workbooks" },
    updateWorkbook: { method: "put", url: "/client_workbooks/{client_workbook_id}" },
};


export const useDashbordsStore = defineStore("dashbord", {
    state: () => ({
        workbooksList: [] as Workbook[],
        workbooksCount: 0,
        workbooksPerPage: 1,
        activeFirst: false,
        addedId: 0,
    }),
    getters: {
        workbookPagesCount: (state) => {
            return Math.ceil(state.workbooksCount / state.workbooksPerPage)
        }
    },
    actions: {
        async getWorkbooks(params: WorkbookParams = { page: 1, per_page: 20 }) {
            await rootGetters.api.proceedRequest(
                endpoints.getWorkbooks, {}, params
            ).then((response) => {
                this.workbooksList = response.data;
                if (this.workbooksList) {
                    this.workbooksPerPage = parseInt(response.headers["x-per-page"]);
                    this.workbooksCount = parseInt(response.headers["x-total-count"]);

                    if (this.addedId > 0) {
                        moveItemToFront(this.workbooksList, this.addedId);
                        this.addedId = 0;
                    }
                }
            });
        },
        async getWorkbook(workbookId: number): Promise<Workbook> {
            return await rootGetters.api.proceedRequest(
                endpoints.getWorkbook, { client_workbook_id: workbookId }
            ).then((response) => {
                return response.data;
            });
        },
        async getToken(workbookId: number, dashboardId: number) {
            return await rootGetters.api.proceedRequest(
                endpoints.getToken, { dashboard_id: dashboardId }, { client_workbook_id: workbookId }
            ).then((response) => {
                return response.data;
            });
        },
        async deleteWorkbook(workbookId: number) {
            await rootGetters.api
                .proceedRequest(endpoints.deleteWorkbook, {
                    client_workbook_id: workbookId,
                })
        },
        async createWorkbook(workbook: WorkbookForCreate) {
            await rootGetters.api
                .proceedRequest(endpoints.createWorkbook, {}, {}, workbook)
                .then((response) => {
                    if (response) {
                        this.addedId = response.data.id;
                        this.activeFirst = true;

                        rootGetters.toast.show(
                            "info",
                            "Создание",
                            `Воркбук "${response.data.name}" успешно сохранен в раздел "Список воркбуков".`
                        );
                    }
                }).catch((err) => {
                    return Promise.reject(err);
                })
        },
        async updateWorkbook(workbook: WorkbookForCreate, workbookId: number) {
            await rootGetters.api
                .proceedRequest(endpoints.updateWorkbook, { client_workbook_id: workbookId }, {}, workbook)
                .then((response) => {
                    if (response) {
                        this.addedId = response.data.id;
                        this.activeFirst = true;

                        rootGetters.toast.show(
                            "info",
                            "Обновление",
                            `Воркбук "${response.data.name}" успешно обновлен.`
                        );
                    }
                }).catch((err) => {
                    return Promise.reject(err);
                })
        },
    },
});

interface WorkbookBase {
    tenant: string;
    name: string;
    include_to_demo_accounts?: boolean;
}

interface DashboardBase {
    name: string;
    description: string;
    datalens_id: string;
    roles_ids?: number[];
}

export interface Dashboard extends DashboardBase {
    id: number;
    roles: Role[];
}

export interface Role {
    id: number;
    department: { id: number };
}


export interface Workbook extends WorkbookBase {
    id: number;
    organization_id: number;
    dashboards: Dashboard[]
}

interface ClientWorkbookForCreate extends WorkbookBase {
    token: string,
    organization_id: number | null,

}

export interface WorkbookForCreate {
    dashboards: DashboardBase[]
    client_workbook: ClientWorkbookForCreate;
}

export interface WorkbookParams {
    page: number;
    per_page: number;
    name?: string;
    name__ilike?: string;

    cdate?: string;
    mdate?: string;

    organization_id__in?: string;
    cuser__id__in?: string;
    dashboards__datalens_id?: string;
    include_demo?: boolean;
    include_to_demo_accounts?: boolean;

    order_by?: string;
}